import React from 'react';
import TopNavbarre from '../composants/topnavbarre';
import Footer from '../composants/footer';
import ContactSection from '../composants/ContactSection';

const Contact = () => {
  return (
    <div>
      <TopNavbarre />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Contact;